import {
    QUESTIONS_ROUTE,
    QUESTION_COVER_ROUTE,
    QUESTION_FEEDBACK_ROUTE,
    QUESTION_DELETE_ROUTE,
    QUESTION_COPY_ROUTE,
    QUESTION_HIDE_ROUTE,
    QUESTION_PIN_ROUTE,
    QUESTION_FEEDBACK_SETTINGS_ROUTE,
    QUESTION_DROP_ROUTE,
} from './constants';

import http from '../../../utils/httpService';

/**
 *
 * @param quizID
 * @param quizLocalizationId
 * @param question
 * @param questionType
 * @param langId
 * @param resolve
 */
const requestQuestionCreation = ( quizID, quizLocalizationId, question, questionType, langId, resolve ) => {
    const questionBody = {
        text: question,
        quiz_id: quizID,
        type: questionType,
        points: 1,
        quiz_localization_id: quizLocalizationId,
        time_for_answer_in_seconds: 1,
        order_number: 1,
        lang_id: langId
    };
    return http.request( QUESTIONS_ROUTE, 'POST', questionBody, false, resolve );
};

/**
 *
 * @param questionPiece
 * @param questionID
 */
const requestQuestionUpdate = ( questionPiece, questionID ) => {
    const route = QUESTIONS_ROUTE + `/${ questionID }`;
    return http.request( route, 'PATCH', questionPiece );
};
/**
 *
 * @param questionID
 * @param localizationID
 * @param image
 * @param screenType
 */
const requestQuestionCoverUpload = ( questionID, localizationID, image, screenType ) => {
    const route = QUESTION_COVER_ROUTE + `/${ questionID }`;
    const requestBody = new FormData();
    const isDesktop = screenType === 'Desktop';

    requestBody.append( 'image', image );
    requestBody.append( 'isDesktop', isDesktop );
    requestBody.append( 'question_localization_id', localizationID );
    return http.request( route, 'POST', requestBody, true );
};
/**
 *
 * @param questionID
 * @param localizationID
 */
const requestQuestionCoverDelete = ( questionID, localizationID ) => {
    const route = QUESTION_COVER_ROUTE + `/${ questionID }`;
    const questionBody = { question_localization_id: localizationID };
    return http.request( route, 'DELETE', questionBody );
};

/**
 *
 * @param questionID
 * @param feedback
 */
const requestQuestionFeedbackUpload = ( questionID, feedback ) => {
    const route = QUESTION_FEEDBACK_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', feedback );
};

/**
 *
 * @param questionID
 * @param feedback
 */
const requestQuestionFeedbackUpdate = ( questionID, feedback ) => {

    const route = QUESTION_FEEDBACK_ROUTE + `/${ questionID }`;
    const requestBody = new FormData();

    requestBody.append( 'image', feedback.feedback.image );
    requestBody.append( 'text', feedback.feedback.text );
    requestBody.append( 'link', feedback.feedback.link );
    requestBody.append( 'id', questionID );

    return http.request( route, 'POST', requestBody, true );
};

/**
 *
 * @param id
 * @param feedbackSettings
 */
const requestQuestionFeedbackSettingsUpdate = ( id, feedbackSettings ) => {
    return http.request( QUESTION_FEEDBACK_SETTINGS_ROUTE, 'POST', feedbackSettings );
};

/**
 *
 * @param questionID
 * @param questionType
 */
const requestQuestionDeleting = ( questionID, questionType ) => {
    const route = QUESTION_DELETE_ROUTE + `/${ questionID }`;
    return http.request( route, 'DELETE', questionType );
};

/**
 *
 * @param questionID
 * @param questionType
 */
const requestQuestionCopy = ( questionID, questionType ) => {
    const route = QUESTION_COPY_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', questionType );
};

/**
 *
 * @param questionID
 * @param questionType
 */
const requestQuestionHide = ( questionID, questionType ) => {
    const route = QUESTION_HIDE_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', questionType );
};
/**
 *
 * @param questionID
 * @param questionType
 */
const requestQuestionPin = ( questionID, questionType ) => {
    const route = QUESTION_PIN_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', questionType );
};
/**
 *
 * @param questionID
 * @param result
 */
const requestQuestionDrop = ( questionID, result ) => {
    const route = QUESTION_DROP_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', result );
};

export {
    requestQuestionCreation,
    requestQuestionUpdate,
    requestQuestionCoverUpload,
    requestQuestionFeedbackUpdate,
    requestQuestionFeedbackSettingsUpdate,
    requestQuestionDeleting,
    requestQuestionCopy,
    requestQuestionHide,
    requestQuestionPin,
    requestQuestionFeedbackUpload,
    requestQuestionDrop,
    requestQuestionCoverDelete,
};
